import BenchlingConfig from 'BenchlingConfig';

import {StructurePredictionModel} from './StructurePredictionConstants';

export function getDefaultStructurePredictionModel(): StructurePredictionModel {
  return BenchlingConfig.MODEL_HUB_ENABLE_STRUCTURE_PREDICTION_MODELS
    ? StructurePredictionModel.BOLTZ2
    : StructurePredictionModel.ALPHAFOLD;
}
